export default [
  {
    name: 'Real-Time NCAA Baseball Rankings',
    description: 'Access the latest rankings updated instantly to keep you always in the know.',
  },
  {
    name: 'Advanced Player Performance Analytics',
    description: 'Dive into deep player analytics for detailed performance insights and trends.',
  },
  {
    name: 'Exclusive Access to Proprietary Data and Insights',
    description: 'Explore unique, in-depth baseball insights not available on any other platform.',
  },
];
